import { render, staticRenderFns } from "./HistoryRecoveryTime.vue?vue&type=template&id=f9ff8e5c&"
import script from "./HistoryRecoveryTime.vue?vue&type=script&lang=js&"
export * from "./HistoryRecoveryTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports